import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect'
import { connect } from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import { OwnershipTransferPrivateSellerStep } from './Constant/Constant';
import { setCurrentStep, setShowPopUp, resetState } from './OwnershipTransferSellerSlice';
import SelectServiceType from './Steps/SelectServiceType';
import SelectStationaryLineType from './Steps/SelectStationaryLineType';
import SelectCellularNumber from './Steps/SelectCellularNumber';
import GeneralMessage from './Steps/GeneralMessage';
import BuyerForm from './Steps/BuyerForm';
import BlockingDualNumberPage from 'app/Components/Shared/BlockingDualNumberPage/BlockingDualNumberPage';
import { ProcssType } from 'app/Components/Shared/BlockingDualNumberPage/constant';

const OwnershipTransferSellerMain = (props) => {


    const generalMessageActions = {
        privateLobby: () => EpiContext.navigateTo(Config.lobbyUrl),
        goToDebtPayment: () => EpiContext.navigateTo(props.iContent.debtPayment.value.url),
        goToUpdatePaymentPage: () => EpiContext.navigateTo(props.iContent.updatePaymentMethod.value.url),
        cancelTechnicianVisit: () => EpiContext.navigateTo(props.iContent.technicianVisit.value.url),
        createWorkOrder: () => props.createWorkOrder(),
        addAnotherRequest: () => { props.resetState(); props.getNextStep(); },
        goToServiceCenterPage: () => EpiContext.navigateTo(props.iContent.serviceCenter.value.url),
    };


    let currentStep = () => {
        switch (props.data.currentStep) {

            case OwnershipTransferPrivateSellerStep.SelectServiceType:
                return <SelectServiceType />;
            case OwnershipTransferPrivateSellerStep.SelectCellularNumber:
                return <SelectCellularNumber iContent={props.iContent} />;
            case OwnershipTransferPrivateSellerStep.SelectStationaryLineType:
                return <SelectStationaryLineType iContent={props.iContent} />;
                case OwnershipTransferPrivateSellerStep.BuyerDetails:
                    return <BuyerForm iContent={props.iContent} />;
            case OwnershipTransferPrivateSellerStep.BlockingDualNumber:
                return <BlockingDualNumberPage subscriberNo={props.data.serviceToTransfer.subscriberNumber} processType={ProcssType.OWNERSHIP_TRANSFER} onSubmit={() => {
                    props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectCellularNumber);
                  }} />

            case OwnershipTransferPrivateSellerStep.GeneralMessage:
                return (
                    <GeneralMessage
                        messageData={props.data.generalMessage}
                        buttonClick={generalMessageActions[props.data.generalMessage?.buttonClick]}
                        secondButtonClick={generalMessageActions[props.data.generalMessage?.secondButtonClick]}
                        linkAction={generalMessageActions[props.data.generalMessage?.linkAction]}
                        secondLinkAction={generalMessageActions[props.data.generalMessage?.secondLinkAction]}
                        iContent={props.iContent}
                    />
                );
            default:
                break;
        }
    };
    return (
        <>{currentStep()}</>
    );
};

const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateSeller,
    productsAndServices: state.selfcarePage
});

const mapDispatchToProps = {
    resetState,
    setCurrentStep,
    setShowPopUp
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferSellerMain);
